// extracted by mini-css-extract-plugin
export default {"cls1":"WhoCanSeePost-cls1_Flg","cls2":"WhoCanSeePost-cls2_LAC WhoCanSeePost-cls1_Flg"};